import { useState, useEffect } from 'react';
import axios, { API, authHeaders, errText } from '../api';
import Layout from './Layout';
import { ui } from '../ui';
import { colors } from '../theme';

function Toggle({ checked, onChange, disabled }) {
  return (
    <div
      onClick={disabled ? undefined : onChange}
      style={{
        width: 44, height: 24, borderRadius: 12, padding: 2, cursor: disabled ? 'default' : 'pointer',
        background: checked ? colors.good : colors.border, transition: 'background 0.15s', opacity: disabled ? 0.5 : 1,
        display: 'flex', justifyContent: checked ? 'flex-end' : 'flex-start',
      }}
    >
      <div style={{ width: 20, height: 20, borderRadius: '50%', background: '#fff' }} />
    </div>
  );
}

export default function CuratorSettings() {
  const [me, setMe] = useState(null);
  const [email, setEmail] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [savedNote, setSavedNote] = useState('');

  useEffect(() => {
    axios.get(`${API}/curator/me`, { headers: authHeaders() }).then(r => {
      setMe(r.data);
      setEmail(r.data.email || '');
    });
  }, []);

  const save = async (payload) => {
    setError('');
    setSaving(true);
    try {
      const r = await axios.patch(`${API}/curator/notification-settings`, payload, { headers: authHeaders() });
      setMe(r.data);
      setSavedNote('Сохранено');
      setTimeout(() => setSavedNote(''), 2000);
    } catch (e) {
      setError(errText(e, 'Не удалось сохранить'));
    }
    setSaving(false);
  };

  const saveEmail = () => save({ email: email.trim() || null });
  const toggleEmailNotify = () => save({ notify_slot_booking_email: !me.notify_slot_booking_email });

  return (
    <Layout>
      <h1 style={ui.title}>Настройки</h1>
      {error && <div style={ui.error}>{error}</div>}
      {!me ? (
        <div style={ui.empty}>Загрузка…</div>
      ) : (
        <div style={ui.card}>
          <div style={{ paddingBottom: 16, borderBottom: `1px solid ${colors.border}` }}>
            <div style={{ fontWeight: 600, color: colors.text, fontSize: 14, marginBottom: 4 }}>Почта для уведомлений</div>
            <div style={{ fontSize: 12, color: colors.textMuted, marginBottom: 10 }}>
              Дублирует push-уведомление о новой записи на собеседование — на случай, если не увидели пуш вовремя.
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                style={{ ...ui.input, flex: 1 }}
              />
              <button style={ui.btn} onClick={saveEmail} disabled={saving}>Сохранить</button>
            </div>
            {savedNote && <div style={{ fontSize: 12, color: colors.good, marginTop: 6 }}>{savedNote}</div>}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 0' }}>
            <div>
              <div style={{ fontWeight: 600, color: colors.text, fontSize: 14 }}>Уведомлять о новой записи на почту</div>
              <div style={{ fontSize: 12, color: colors.textMuted, marginTop: 2 }}>
                {me.email ? 'Письмо придёт на адрес выше' : 'Сначала укажите и сохраните почту'}
              </div>
            </div>
            <Toggle checked={me.notify_slot_booking_email} onChange={toggleEmailNotify} disabled={saving || !me.email} />
          </div>
        </div>
      )}
    </Layout>
  );
}
